import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { PropertyProvider } from './contexts/PropertyContext';
import AppRoutes from './routes/AppRoutes';

const App = () => {
  return (
    <>
      <BrowserRouter>
        <AuthProvider>
          <PropertyProvider>
            <AppRoutes />
          </PropertyProvider>
        </AuthProvider>
      </BrowserRouter>
    </>
  );
};

export default App;